export const menuTitle = { title: "PRODUCT PRICING LEVEL", label: "Product Pricing Level" }
  